import { Typography, TypographyProps } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import * as React from 'react'
import styles from './SheetViews.module.css'

export function CarSelectedSheetTrigger({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props} className={cn(styles.carSelectedSheetTrigger, className)}>
      {children}
    </div>
  )
}

export function CarSelectedSheetTriggerContent({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props} className={cn(styles.carSelectedSheetTriggerContent, className)}>
      {children}
    </div>
  )
}

export function CarSelectedSheetContent({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props} className={cn(styles.carSelectedSheetContent, className)}>
      {children}
    </div>
  )
}

export function CarSelectedSheetCategoryText({ className, children, ...props }: TypographyProps) {
  return (
    <Typography {...props} className={cn(styles.carSelectedSheetCategoryText, className)}>
      {children}
    </Typography>
  )
}

export function CarSelectedSheetHintText({ className, children, ...props }: TypographyProps) {
  return (
    <Typography {...props} className={cn(styles.carSelectedSheetCategoryHintText, className)}>
      {children}
    </Typography>
  )
}

export function CarSelectedSheetTrailing({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props} className={cn(styles.carSelectedSheetTrailing, className)}>
      {children}
    </div>
  )
}

export function CarListName({ className, children, ...props }: TypographyProps) {
  return (
    <Typography {...props} className={cn(styles.carListName, className)}>
      {children}
    </Typography>
  )
}

export function CarSheetContent({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props} className={cn(styles.carSheetContent, className)}>
      {children}
    </div>
  )
}
